export const messagingMethods = {
  methods: [
    {
      id: 1,
      code: 'sms',
      name: 'SMS',
      available: true,
      img_url:
        'https://storage.googleapis.com/kem-catalog-stage/messaging/sms.png',
    },
    {
      id: 3,
      code: 'telegram',
      name: 'Telegram',
      available: true,
      img_url:
        'https://storage.googleapis.com/kem-catalog-stage/messaging/telegram.png',
    },
    {
      id: 2,
      code: 'whatsapp',
      name: 'WhatsApp',
      available: true,
      img_url:
        'https://storage.googleapis.com/kem-catalog-stage/messaging/whatsapp.png',
    },
  ],
}
